import { detect } from "detect-browser";

export const browser = detect();
export const isBrowserRecommended = browser && browser.name === "chrome";
export const isBrowserSupported =
  browser && (browser.name === "chrome" || browser.name === "firefox" || browser.name === "safari");
